import AzureResourceCSP from "../../models/csp/AzureResourceCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  methods: {
    getAzureResourcesCSP: async function (
      customerId: string,
      azurePlanId: string
    ): Promise<AzureResourceCSP[]> {
      const res = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${customerId}/subscriptions/${azurePlanId}/meterusagerecords`
      );
      return res.items.map(azResource => {
        return new AzureResourceCSP({
          subcategory: azResource.subcategory,
          totalCost: azResource.totalCost,
          azurePlanId: azResource.subscriptionId // Refers to Azure Plan Id, but is considered as any other Microsoft "Subscription" Id
        });
      });
    }
  }
};
